// src/data/exercises/L5_03.js

const accountOptions = [
  '現金', '未収金', '有価証券', '有価証券売却益', '有価証券売却損'];

export const L5_03 = {
  title: '簿記　3級（第214-3回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

       parts: [
    { "type": "ruby", "text": "保有", "ruby": "ほゆう" },
    { "type": "text", "value": "している" },
    { "type": "ruby", "text": "佐賀商事株式会社", "ruby": "さがしょうじかぶしきがいしゃ" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "株式", "ruby": "かぶしき" },
    { "type": "text", "value": "300" },
    { "type": "ruby", "text": "株", "ruby": "かぶ" },
    { "type": "text", "value": "（" },
    { "type": "ruby", "text": "帳簿価額", "ruby": "ちょうぼかがく" },
    { "type": "text", "value": "＠￥1,700）を＠￥1,400で" },
    { "type": "ruby", "text": "全株売却", "ruby": "ぜんかぶばいきゃく" },
    { "type": "text", "value": "し、" },
    { "type": "ruby", "text": "代金", "ruby": "だいきん" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "後日", "ruby": "ごじつ" },
    { "type": "text", "value": " " },
    { "type": "ruby", "text": "振", "ruby": "ふ" },
    { "type": "text", "value": "り込まれることとなった。" }
]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '未収金', debitAmount: 420000, creditAccount: '有価証券', creditAmount: 510000 },
        { debitAccount: '有価証券売却損', debitAmount: 90000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '「株式を売却」　「株式」は「有価証券」を使います。\n' },
          { type: 'styled', value: '①有価証券は売却すると減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },

          { type: 'text', value: '「代金は後日振り込まれる」　「後日」は、後でなので\n' },
          { type: 'styled', value: '②未収金（まだもらってない）が増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '差額は、\n' },
          { type: 'styled', value: '③もらうお金が多いときor右が足りないときは「有価証券売却益」を使う', color: 'red', bold: true },
          { type: 'styled', value: 'もらうお金が少ないときor左が足りないときは「有価証券売却損」を使う', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「株式を売却」　「株式」は「有価証券」を使います。
①	有価証券は売却すると減少（マイナス）します。

「代金は後日振り込まれる」　「後日」は、後でなので
②	未収金（まだもらってない）が増加（プラス）します。

差額は、
③もらうお金が多いときor右が足りないときは「有価証券売却益」を使う
もらうお金が少ないときor左が足りないときは「有価証券売却損」を使う


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
                   parts: [
          { type: 'text', value: '「株式を売却」　「株式」は「有価証券」を使います。\n' },
          { type: 'styled', value: '①有価証券は売却すると減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },

          { type: 'text', value: '「代金は後日振り込まれる」　「後日」は、後でなので\n' },
          { type: 'styled', value: '②未収金（まだもらってない）が増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '差額は、\n' },
          { type: 'styled', value: '③もらうお金が多いときor右が足りないときは「有価証券売却益」を使う', color: 'red', bold: true },
          { type: 'styled', value: 'もらうお金が少ないときor左が足りないときは「有価証券売却損」を使う', color: 'red', bold: true },
        ]
          }
        ],
       
      },
    },
  ],
};